import { lazy, useEffect } from 'react';
import Cookie from 'js-cookie';
import * as styles from './styles.css';
import View from '../../components/view';
const AnalyzingApplicationDialog = lazy(
  () => import('../../components/analyzing-application-dialog'),
);
import { useFlags as useLaunchDarklyFlags } from 'launchdarkly-react-client-sdk';
import { useAtomValue, useSetAtom } from 'jotai/react';
import { topSubjectsFeatureFlag } from '../../atoms/featureFlag';
import application from '../../atoms/application';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Sections from '../../components/sections';

export interface IHomeProps {
  id?: string;
}

const Home = ({ id }: IHomeProps) => {
  const launchDarklyFlags = useLaunchDarklyFlags();
  const topSubjectsFlag = launchDarklyFlags['MOESRC-161-top-subjects'];
  const isHireVueLinkEnabled = launchDarklyFlags['MOESRC-153-hireview-link-in-thank-you-page'];
  const setSubjectsFlag = useSetAtom(topSubjectsFeatureFlag);
  const isApplicationComplete = useAtomValue(application.is_complete);

  useEffect(() => {
    const hasVisitorId = Cookie.get('visitor_id');
    if (!hasVisitorId && crypto && crypto.randomUUID) {
      const domainWithoutSubdomain = process.env.VITE_DOMAIN_NAME?.split('.').slice(-2).join('.');
      Cookie.set('visitor_id', crypto.randomUUID(), { domain: domainWithoutSubdomain });
    }
  }, []);

  useEffect(() => {
    setSubjectsFlag(topSubjectsFlag);
  }, [topSubjectsFlag, setSubjectsFlag]);

  return (
    <div id={id} className={styles.home}>
      <Header />
      <div className={styles.flex}>
        <Sections />
        <View />
      </div>
      <Footer />

      {isHireVueLinkEnabled && isApplicationComplete && <AnalyzingApplicationDialog />}
    </div>
  );
};

export default Home;
